<div class="normatives-table-container">
  <div class="normatives-table__toolbar">
    <span class="normatives-table__toolbar-text">Наведите на ячейку, чтобы выбрать или отредактировать</span>
    <div class="normatives-table__actions">
      <button class="button button--secondary" [disabled]="changedCells.length === 0" (click)="onOverwriteSelected()">
        Перезаписать выбранные нормативы ({{ changedCells.length }})
      </button>
      <button class="button button--secondary" [disabled]="changedCells.length === 0" (click)="onOverwriteAll()">Перезаписать все нормативы</button>
    </div>
  </div>

  <div class="tbl">
    <div class="tbl__inner">
      <table class="normatives-table">
        <thead class="normatives-table__header">
          <tr>
            <th *ngFor="let header of headers" class="normatives-table__th">{{ header }}</th>
          </tr>
        </thead>
        <tbody class="normatives-table__body">
          <tr *ngFor="let row of rows; let rowIndex = index">
            <td class="normatives-table__td">{{ row.workTypeName }}</td>
            <td
              *ngFor="let cell of row.cells; let colIndex = index"
              class="normatives-table__td"
              [class.normatives-table__td--editable]="cell && !isTotalCell(colIndex)"
              [class.normatives-table__td--changed]="cell && cell.isChanged"
              [class.normatives-table__td--total]="isTotalCell(colIndex)"
            >
              <ng-container *ngIf="cell">
                <div *ngIf="!cell.isEditing" class="normatives-table__cell-view">
                  <span>{{ formatValue(cell.value) }}</span>
                  <button *ngIf="!isTotalCell(colIndex)" class="normatives-table__edit-btn" (click)="startEditing(cell, row, rowIndex, colIndex)">✏️</button>
                </div>

                <div *ngIf="cell.isEditing" class="normatives-table__cell-edit">
                  <input
                    type="number"
                    class="input normatives-table__input"
                    [value]="cell.value"
                    (input)="cell.value = +$event.target.value"
                    (keyup.enter)="saveCell(cell, row)"
                    (keyup.escape)="cancelEditing(cell)"
                  />
                  <div class="normatives-table__edit-actions">
                    <button class="normatives-table__action-btn" (click)="saveCell(cell, row)">✔️</button>
                    <button class="normatives-table__action-btn" (click)="cancelEditing(cell)">❌</button>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!cell">-</ng-container>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0">
            <td [attr.colspan]="headers.length" class="normatives-table__td text-center">Нет данных</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
